import api from "./api";

// 课程列表
export const postCourseList = params => {
  return api("post", `/v1/management/course`, params);
};

// 课程类型列表
export const getCourseTypeList = params => {
  return api("get", `/v1/management/course/course-type-list`, params);
};

// 删除课程
export const deleteCourse = (params, config) => {
  return api("delete", `/v1/management/course`, params, config);
};

// 新增课程
// export const putAddCourse = params => {
//   return api("put", `/v1/management/course/add`, params);
// };

export const putAddCourse = params => {
  return api("put", `/v2/management/course/add`, params);
};

// 下架
export const postOfflineCourse = params => {
  return api("post", `/v1/management/course/offline`, params);
};

// 上架
export const postOnlineCourse = params => {
  return api("post", `/v1/management/course/online`, params);
};

// 置顶
export const postStickyCourse = params => {
  return api("post", `/v1/management/course/sticky`, params);
};

// 取消置顶
export const postUnStickyCourse = params => {
  return api("post", `/v1/management/course/cancel-sticky`, params);
};

// 更新课程
// export const postUpdateCourse = params => {
//   return api("post", `/v1/management/course/update`, params);
// };
export const postUpdateCourse = params => {
  return api("post", `/v2/management/course/update`, params);
};

export const postCourseTag = params => {
  return api("post", `/v1/management/course/tag`, params);
};

// 课程详情
// export const getCourseDetails = params => {
//   return api("get", `/v1/management/course/${params}`);
// };

export const getCourseDetails = params => {
  return api("get", `/v2/management/course/${params}`);
};

// 课程排序
export const postSortCourse = params => {
  return api("post", `/v1/management/course/sort`, params);
};

// 导出课程
export const getExportCourse = params => {
  return api("get", `/v1/management/course/excel/download`, params, {
    responseType: "blob",
  });
};

// 导入课程
export const postImportCourse = file => {
  const formData = new FormData();
  formData.append("file", file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", `/v1/management/course/excel/upload`, formData, config);
};
